<template>
    <div class="c-loader__container" :class="{'c-loader__container--loading' : loading}">
        <template v-if="loading">
            <c-loader></c-loader>
        </template>
        <template v-else>
            <slot></slot>
        </template>
    </div>
</template>

<script>

import CLoader from '@components/loader/Animation';

export default {
    name: 'loader-container',
    components: { CLoader },
    props: {
        loading: {
            type: Boolean,
            default: true
        }
    }
}

/**
 * Usage:
 * <c-loading-container :loading="boolean">
 *      <h1>Data to show after loading</h1>
 * </c-loading-container>
 * 
 * import CLoadingContainer from '@components/loader/Container
 * 
 * export default {
 *      components: { CLoadingContainer },
 *      data() {
 *          return { boolean: true }
 *      }
 * }
 */
</script>
